export interface CarrierDiscoveryReviewPresentationInput {
  accountCount: number;
  vendorCount: number;
  sourceComplete: boolean;
  sourceTruncated: boolean;
  hasMoreAccounts: boolean;
  hasMoreVendors: boolean;
}

function recordCount(count: number, singular: string, plural: string): string {
  return `${count} ${count === 1 ? singular : plural}`;
}

export function getCarrierDiscoveryReviewPresentation(
  input: CarrierDiscoveryReviewPresentationInput
) {
  const boundedPreview = input.hasMoreAccounts || input.hasMoreVendors;
  const found = [];
  if (input.accountCount > 0) {
    found.push(recordCount(input.accountCount, 'account', 'accounts'));
  }
  if (input.vendorCount > 0) {
    found.push(recordCount(input.vendorCount, 'carrier', 'carriers'));
  }
  const summary = found.length > 0 ? `${found.join(' and ')} found` : 'Nothing found yet';

  if (input.sourceTruncated) {
    return {
      summary,
      notice: 'Some results may be missing. Review the available records before continuing.',
    };
  }
  if (!input.sourceComplete) {
    return {
      summary,
      notice: '',
    };
  }
  if (boundedPreview) {
    return {
      summary,
      notice: 'Showing the first results. More are available for review.',
    };
  }
  return {
    summary,
    notice: '',
  };
}
